module.exports = __webpack_public_path__ + "img/horizontal_4_3_8004.a288d7ae.png";